<template>
    <div v-if="!showConfirm" class="container-fluid pl-0 pr-0">

        <h2>Forgot your password?</h2>
        <h4>Enter your email</h4>
        <hr>
            <form id="app">
                <div class="form-group">
                    <div class="row">
                        <label asp-for="Password" class="col-2 d-flex align-self-center justify-content-end">
                            Email
                            <span class="required">*</span>
                        </label>
                        <div class="col-4">
                            <input class="form-control rounded-0" type="email" id="Email" name="Email" v-model="email">
                        </div>
                    </div>
                    <div class="row" v-if="v$.email.$error">
                        <div class="text-danger small col-4 offset-2" v-for="error of v$.email.$silentErrors" :key="error.$message">
                            {{ error.$message }}
                        </div>
                    </div>
                    <div class="row" v-if="showFailure">
                        <div class="text-danger small col-4 offset-2">
                            Request Submission Failed
                        </div>
                    </div>
                </div>
            <div class="form-group">
                <div class="row">
                    <div class="col-8 offset-2">
                        <input id="Submit" type="submit" class="btn btn-light" :disabled="v$.$invalid" value="Submit" @click.prevent="postForm" />
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div v-if="showConfirm">
        <h2>Forgot Password Confirmation</h2>
        <hr />
        <div class="d-flex flex-column">
            <p>Please check your email to reset your password.</p>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import accountApiClient from '@/services/apiServices/accountApiClient.js'
    import useVuelidate from '@vuelidate/core'
    import { required, email } from '@vuelidate/validators'

    export default {
        name: 'ForgotPassword',
        setup() {
            return { v$: useVuelidate() }
        },
        data() {
            return {
                email: "",
                showConfirm: false,
                showFailure: false
            }
        },
        validations() {
            return {
                email: { required, email, $autoDirty: true },
            }
        },
        computed: {
            ...mapState({
                instance: state => state.instance,
            })
        },
        methods: {
            postForm: async function () {
                var confirmResult = await accountApiClient.ForgotPassword(this.email);
                if (confirmResult.status == 200 && confirmResult.data.success == true) {
                    this.showConfirm = true;
                    this.showFailure = false;
                } else { // bad response
                    this.showConfirm = false;
                    this.showFailure = true;
                }
            }
        }
    }
</script>

<style scoped>
</style>